module.exports = __webpack_public_path__ + "img/field-shelter-a991fb4.png";